export default __webpack_public_path__ + "03ef6fb6d47a03caa37d3a87900fabeb.wasm";